import React from "react";

import SearchDropdown from "@cayuse/shared-react.components.search-dropdown";
import Icon from "@cayuse/shared-react.components.icon";
import IconButton from "@cayuse/shared-react.components.icon-button";

import { QuestionFooter, QuestionHeader } from "./Question";
import styles from "./S2SIntegrationComponent.css";
import { generateValue } from "../SimplifiedFormBuilderPalette/utils";

/**
 * Correction for all previously created the cayuseProposalsS2SRecord components. (when initialValues was specified as null)
 */
const extendConfigWithValue = (config) => {
	if (config.value === undefined) {
		config.value = generateValue();
	}
	return config;
};

function S2SIntegrationComponent ({ completeFormModel, config, onChange, onDelete }) {
	const onChangeConfig = newProps => onChange({ ...extendConfigWithValue(config), ...newProps });

	return (
		<>
			<QuestionHeader config={config} onChangeConfig={onChangeConfig} />
			<div className={`ui form ${styles.container}`}>
				<div className={`ui input ${styles.input}`}>
					<label>
						Link to existing Proposals (S2S) Record
					</label>
					<SearchDropdown
						disabled
						selection
						className={styles.searchFundingProgram}
						placeholder="Search by proposal name…"
						fieldLabel="Link to existing Proposals (S2S) Record"
					/>
				</div>
				<div>OR</div>
				<label>Create new Grants.gov proposal</label>
				<div className={`ui input ${styles.input}`}>
					<label>
						Proposals (S2S) Opportunity Search
					</label>
					<SearchDropdown
						disabled
						selection
						className={styles.searchFundingProgram}
						placeholder="Search by opportunity title or opportunity number"
						fieldLabel="Proposals (S2S) Opportunity Search"
					/>
				</div>
				<div className={styles.iconButton}>
					<IconButton icon="plus" disabled={true} primary>
						Create New Proposal (S2S) Record
					</IconButton>
				</div>
				<div>OR</div>
				<a>Go to Proposals (S2S) <Icon name="arrow-up-right-from-square"/></a>
			</div>
			<QuestionFooter
				completeFormModel={completeFormModel}
				config={config}
				onChangeConfig={onChangeConfig}
				onDelete={onDelete}
			>
			</QuestionFooter>
		</>
	);
}

S2SIntegrationComponent.showInPalette = () => true;

S2SIntegrationComponent.paletteInformation = () => ({
	id: "cayuseProposalsS2SRecord",
	name: "SP-S2S Integration",
	type: "cayuseProposalsS2SRecord",
	group: "sponsoredProject"
});

S2SIntegrationComponent.newElement = () => ({
	designInfo: {
		stencilSuperIds: [
			"Component"
		],
		stencilId: "cayuse-proposals-s2s-record",
		customStencilId: "null"
	},
	type: "cayuseProposalsS2SRecord",
	cayuseShortLabel: "SP-S2S Integration"
});

S2SIntegrationComponent.initialValue = "{{proposalsS2SRecord}}";


export default S2SIntegrationComponent;
